<app-chat [isUnaunthenticatedChat]="false"></app-chat>
<ion-toolbar>
  <div class="logos">
    <div class="custom-logo">
      <div class="brand-logo"
        [ngClass]="brandedBottomNavigationColorIsBrightness ? 'brand-logo-dark' : 'brand-logo-white'">
      </div>
    </div>
    <div class="footer-links">
      <ion-grid class="links-grid">
        <ion-row>
          <ion-col size="auto" *ngFor="let link of footerLinks">
            <a (click)="footerLinkClick(link)">{{ link.name }}</a>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
  <ion-row class="footer-copy-row">
    <div class="footer-copy-box" *ngIf="footerCopy">
      <div class="footer-copy">
        <p [innerHTML]="footerCopy"></p>
      </div>
    </div>
  </ion-row>
  <div class="version"> Version {{ appVersion }} <span *ngIf="isPreviewMode"> | Preview Mode: TRUE</span></div>
</ion-toolbar>